import React, { useContext, useEffect, useState } from "react";
import { Accordion, Card, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { Input, InputDecimal, Select } from "../../../../../components/Form";
import {
  situacao,
  status,
  trueOuFalse,
} from "../../../../../components/Form/Select/options";
import api from "../../../../../services/api";

import { ProdutoContext } from "../../../../../contexts/produtos/produtosContext";

const PerfilTabGeral: React.FC<any> = ({
  selectValues,
  setLogoLinha,
  loadingValues,
  material,
}) => {
  // URL Params
  const { pId }: any = useParams();

  // É um novo componente?
  const novo = pId == 0;

  const perfilComposto = [
    { label: "Não", value: 0 },
    { label: "Sim", value: 3 },
    { label: "Interno", value: 1 },
    { label: "Externo", value: 2 },
  ];

  const MaisDeUmTamanhoBarra = [
    { label: "Não", value: false },
    { label: "Sim", value: true },
  ];

  const handleMaisTamanhoBarraChange = (selectedOption: any) => {
    if (selectedOption) {
      const maisDeUma = selectedOption.value === true;

      setMaisDeUmaBarra(!maisDeUma);

      selectValues.formRef?.current?.setFieldValue(
        "barra1",
        maisDeUma ? 0 : 6000
      );

      handleChangeField();
    }
  };

  // Contexts
  const produtoContext = useContext(ProdutoContext);
  // //States
  const [linha, setLinha] = useState<any>([]);
  const [maisDeUmaBarra, setMaisDeUmaBarra] = useState(true);
  const [prenativo, setPrenativo] = useState<any>([]);
  const [unidadeValorizacao, setUnidadeValorizacao] = useState([]);
  const [classeIds, setClasseIds] = useState<any>([]);

  //Effects
  useEffect(() => {
    produtoContext.setEntrouEmEdicao(false);
  }, []);

  if (
    !produtoContext.entrouEmEdicao &&
    selectValues &&
    selectValues.liga?.length > 0 &&
    material &&
    material.liga == null
  ) {
    const liga6060 = selectValues.liga.find((p: any) => p.label == "6060");
    const temperaT5 = selectValues.tempera.find((p: any) => p.label == "T5");
    selectValues.formRef?.current?.setFieldValue("liga", liga6060);
    selectValues.formRef?.current?.setFieldValue("tempera", temperaT5);
  }

  useEffect(() => {
    if (
      produtoContext.entrouEmEdicao &&
      Object.keys(selectValues).length != 0
    ) {
      selectValues.formRef?.current?.setFieldValue("situacao", situacao[0]);
    }
  }, [produtoContext.entrouEmEdicao]);

  //Handles
  const handleReferenciaLinha = async ({ value }: any) => {
    selectValues.formRef?.current?.clearField("linha");

    const { data } = await api.get(`linha/select/${value}`);

    await api
      .get(`geral/SelecaoClassePorReferenciaId/${value}`)
      .then((data) => {
        setClasseIds(data.data);
      });

    setLinha(data);

    handleChangeField();
  };

  const handleLinha = async (e: any) => {
    if (e != undefined) {
      Promise.all([
        api.get(`geral/logoLinha/${e.value}`),
        api.get(`geral/selecaoPrenativo/${e.value}`),
        api.get("geral/selecaoUnidadePerfil"),
      ]).then(([logoLinha, prenativo, unidadeValor]) => {
        setLogoLinha(logoLinha.data);
        setUnidadeValorizacao(unidadeValor.data);
        setPrenativo(prenativo.data);
      });
      //await fetchTemperaOptions(e.value);
    }
    handleChangeField();
  };

  const handleChangeField = () => {
    if (!produtoContext.entrouEmEdicao && !loadingValues) {
      produtoContext.setEntrouEmEdicao(true);
    }
  };
  useEffect(() => {
    if (maisDeUmaBarra && !loadingValues) {
      selectValues.formRef?.current?.setFieldValue("barra1", 6000);
    }
  }, [loadingValues]);

  return (
    <>
      <div className={"dimmer" + (loadingValues ? " active" : "")}>
        <div className="loader"></div>
        <div
          className={
            "dimmer-content" + (loadingValues ? " medium-box-loader" : "")
          }
        >
          <div className="form-row mt-4">
            <div className="form-group col">
              <label className="form-label">Status *</label>
              <Select
                name="status"
                options={status}
                placeholder="Selecione uma opção..."
                defaultValue={novo ? status[0] : ""}
                isDisabled={novo}
                onChange={handleChangeField}
              />
            </div>
            <div className="form-group col">
              <label className="form-label">Situação *</label>
              <Select
                name="situacao"
                options={situacao}
                placeholder="Selecione uma opção..."
                defaultValue={novo ? situacao[0] : ""}
              />
            </div>
            <Form.Group className="col">
              <Form.Label>Código *</Form.Label>
              <Input
                type="text"
                name="codigo"
                className="form-control"
                placeholder="Código..."
                onChange={handleChangeField}
                disabled={!novo}
              />
            </Form.Group>
            <Form.Group className="col">
              <Form.Label>Código Interno</Form.Label>
              <Input
                type="text"
                name="codigoInterno"
                className="form-control"
                placeholder="Código Interno..."
                onChange={handleChangeField}
              />
            </Form.Group>
          </div>

          <div className="form-row">
            <div className="form-group col">
              <label className="form-label">Referência *</label>
              <Select
                name="referencia"
                options={selectValues.referencia}
                onChange={(e) => {
                  handleReferenciaLinha(e);
                }}
                placeholder="Selecione uma opção..."
              />
            </div>
            <div className="form-group col">
              <label className="form-label">Linha *</label>
              <Select
                name="linha"
                options={linha}
                defaultValue={selectValues.linha}
                onChange={(e) => {
                  selectValues.formRef?.current?.clearField("prenativo");
                  handleLinha(e);
                }}
                placeholder="Selecione uma opção..."
              />
            </div>
          </div>

          <Form.Row>
            <Form.Group className="col">
              <Form.Label>Descrição *</Form.Label>
              <Input
                type="text"
                name="descricao"
                className="form-control"
                placeholder="Descrição..."
                onChange={handleChangeField}
              />
            </Form.Group>
          </Form.Row>

          <Form.Row>
            <Form.Group className="col">
              <Form.Label>Peso *</Form.Label>
              <InputDecimal
                type="text"
                name="peso"
                className="form-control"
                placeholder="0,000..."
                displayType="input"
                onChange={handleChangeField}
                thousandSeparator={false}
                decimalSeparator=","
                valueIsNumericString
                decimalScale={3}
                fixedDecimalScale={true}
                isAllowed={(values: any) => {
                  const { formattedValue, floatValue } = values;
                  return formattedValue === "" || floatValue <= 999;
                }}
              />
            </Form.Group>
            <Form.Group className="col">
              <label className="form-label">Unidade de Valorização *</label>
              <Select
                name="unidadeValorizacao"
                options={unidadeValorizacao}
                placeholder="Selecione uma opção..."
                onChange={handleChangeField}
              />
            </Form.Group>
            <Form.Group className="col">
              <label className="form-label">Medida Especial *</label>
              <Select
                name="maisDeUmTamanhoBarra"
                options={MaisDeUmTamanhoBarra}
                placeholder="Selecione uma opção..."
                onChange={handleMaisTamanhoBarraChange}
              />
            </Form.Group>
            {maisDeUmaBarra && (
              <Form.Group className="col">
                <Form.Label>Tamanho da barra *</Form.Label>
                <InputDecimal
                  type="text"
                  name="barra1"
                  className="form-control"
                  placeholder=""
                  displayType="input"
                  decimalSeparator=","
                  valueIsNumericString
                  maxLength={4}
                  value={6000}
                  defaultValue={6000}
                  disabled
                  onValueChange={(values) => {
                    const { floatValue } = values;
                    selectValues.formRef?.current?.setFieldValue(
                      "barra1",
                      floatValue ?? ""
                    );
                    handleChangeField();
                  }}
                  isAllowed={(values: any) => {
                    const { formattedValue, floatValue } = values;
                    return (
                      formattedValue === "" ||
                      (floatValue !== undefined && floatValue <= 9999)
                    );
                  }}
                />
              </Form.Group>
            )}
          </Form.Row>

          <div className="form-row">
            <div className="form-group col">
              <label className="form-label">Classe / ID *</label>
              <Select
                name="classeId"
                options={classeIds}
                placeholder="Selecione uma opção..."
                onChange={handleChangeField}
              />
            </div>
            <div className="form-group col">
              <label className="form-label">Prenativo *</label>
              <Select
                name="prenativo"
                options={prenativo}
                placeholder="Selecione uma opção..."
                defaultValue={selectValues.prenativo}
                onChange={handleChangeField}
              />
            </div>
          </div>

          <div className="form-row">
            <Form.Group className="col">
              <Form.Label>IPI</Form.Label>
              <InputDecimal
                type="text"
                name="ipi"
                className="form-control"
                placeholder="0,00..."
                displayType="input"
                onChange={handleChangeField}
                thousandSeparator={false}
                decimalSeparator=","
                valueIsNumericString
                decimalScale={2}
                fixedDecimalScale={true}
                isAllowed={(values: any) => {
                  const { formattedValue, floatValue } = values;
                  return formattedValue === "" || floatValue <= 99;
                }}
              />
            </Form.Group>

            <div className="form-group col">
              <label className="form-label">Não Considerar Perda</label>
              <Select
                name="perda"
                options={trueOuFalse}
                placeholder="Selecione uma opção..."
                defaultValue={trueOuFalse[1]}
                onChange={handleChangeField}
              />
            </div>
            <div className="form-group col">
              <label className="form-label">Perfil Composto</label>
              <Select
                name="composto"
                options={perfilComposto}
                placeholder="Selecione uma opção..."
                defaultValue={perfilComposto[0]}
                onChange={handleChangeField}
              />
            </div>
          </div>

          <Accordion>
            <Card>
              <Accordion.Toggle as={Card.Header} eventKey="0">
                <a className="btn">Informações Adicionais</a>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <div className="form-row">
                    <div className="form-group col">
                      <label className="form-label">Liga</label>
                      <Select
                        name="liga"
                        options={selectValues.liga}
                        placeholder="Selecione uma opção..."
                        onChange={async (e) => {
                          handleLinha(e);
                        }}
                      />
                    </div>
                    <div className="form-group col">
                      <label className="form-label">Tempera</label>
                      <Select
                        name="tempera"
                        options={selectValues.tempera}
                        placeholder="Selecione uma opção..."
                        onChange={handleChangeField}
                      />
                    </div>
                  </div>

                  <Form.Row>
                    <Form.Group className="col">
                      <Form.Label>WX</Form.Label>
                      <InputDecimal
                        type="text"
                        name="wxt"
                        className="form-control"
                        placeholder="0,000..."
                        displayType="input"
                        onChange={handleChangeField}
                        thousandSeparator={false}
                        decimalSeparator=","
                        valueIsNumericString
                        decimalScale={3}
                        fixedDecimalScale={true}
                        isAllowed={(values: any) => {
                          const { formattedValue, floatValue } = values;
                          return formattedValue === "" || floatValue <= 999;
                        }}
                      />
                    </Form.Group>
                    <Form.Group className="col">
                      <Form.Label>JX</Form.Label>
                      <InputDecimal
                        type="text"
                        name="jxt"
                        className="form-control"
                        placeholder="0,000..."
                        displayType="input"
                        onChange={handleChangeField}
                        thousandSeparator={false}
                        decimalSeparator=","
                        valueIsNumericString
                        decimalScale={3}
                        fixedDecimalScale={true}
                        isAllowed={(values: any) => {
                          const { formattedValue, floatValue } = values;
                          return formattedValue === "" || floatValue <= 999;
                        }}
                      />
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group className="col">
                      <Form.Label>WY</Form.Label>
                      <InputDecimal
                        type="text"
                        name="wy"
                        className="form-control"
                        placeholder="0,000..."
                        displayType="input"
                        onChange={handleChangeField}
                        thousandSeparator={false}
                        decimalSeparator=","
                        valueIsNumericString
                        decimalScale={3}
                        fixedDecimalScale={true}
                        isAllowed={(values: any) => {
                          const { formattedValue, floatValue } = values;
                          return formattedValue === "" || floatValue <= 999;
                        }}
                      />
                    </Form.Group>
                    <Form.Group className="col">
                      <Form.Label>JY</Form.Label>
                      <InputDecimal
                        type="text"
                        name="jy"
                        className="form-control"
                        placeholder="0,000..."
                        displayType="input"
                        onChange={handleChangeField}
                        thousandSeparator={false}
                        decimalSeparator=","
                        valueIsNumericString
                        decimalScale={3}
                        fixedDecimalScale={true}
                        isAllowed={(values: any) => {
                          const { formattedValue, floatValue } = values;
                          return formattedValue === "" || floatValue <= 999;
                        }}
                      />
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group className="col">
                      <Form.Label>Perímetro Total</Form.Label>
                      <InputDecimal
                        type="text"
                        name="perimetroTotal"
                        className="form-control"
                        placeholder="0,000..."
                        displayType="input"
                        onChange={handleChangeField}
                        thousandSeparator={false}
                        decimalSeparator=","
                        valueIsNumericString
                        decimalScale={3}
                        fixedDecimalScale={true}
                        isAllowed={(values: any) => {
                          const { formattedValue, floatValue } = values;
                          return formattedValue === "" || floatValue <= 999;
                        }}
                      />
                    </Form.Group>
                    <Form.Group className="col">
                      <Form.Label>Perímetro de Tratamento</Form.Label>
                      <InputDecimal
                        type="text"
                        name="perimetroTratamento"
                        className="form-control"
                        placeholder="0,000..."
                        displayType="input"
                        onChange={handleChangeField}
                        thousandSeparator={false}
                        decimalSeparator=","
                        valueIsNumericString
                        decimalScale={3}
                        fixedDecimalScale={true}
                        isAllowed={(values: any) => {
                          const { formattedValue, floatValue } = values;
                          return formattedValue === "" || floatValue <= 999;
                        }}
                      />
                    </Form.Group>
                  </Form.Row>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>
      </div>
    </>
  );
};
export default PerfilTabGeral;
